const CTASection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-red-dark to-red">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 px-4">
          まずは無料相談から<br className="sm:hidden" />始めませんか？
        </h2>
        <p className="text-base sm:text-lg text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto px-4">
          あなたのビジネスの課題をお聞かせください。<br className="hidden sm:block" />
          最適なソリューションをご提案いたします。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-white text-red px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-[15px] font-medium hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-center"
          >
            無料相談を予約する
          </a>
          <a
            href="tel:075-351-0587"
            className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-[15px] font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line text-lg"></i>
            <span>075-351-0587</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
